import create from 'zustand';

type Store = {
  isCreateModal: boolean;
  isCreateDamageModal: boolean;
  isCreateIndpinModal: boolean;
  isCreateTrapModal: boolean;
  isCreateCameraModal: boolean;
  isCreatePrevModal: boolean;//柵用20230412追記
  isExpPictureModal: boolean;//画像用20230407追記
  isCreateReportModal: boolean;//報告書用20240410追記
  createModalToggle: () => void;
  createModalClose: () => void;
  createDamageModalOpen: () => void;
  createDamageModalClose: () => void;
  createIndpinModalOpen: () => void;
  createIndpinModalClose: () => void;
  createTrapModalOpen: () => void;
  createTrapModalClose: () => void;
  createCameraModalOpen: () => void;
  createCameraModalClose: () => void;
  createPrevModalOpen: () => void;//柵用20230412追記
  createPrevModalClose: () => void;//柵用20230412追記
  createPictureModalOpen: () => void;//画像用20230407追記
  createPictureModalClose: () => void;//画像用20230407追記
  createReportModalOpen: () => void;//報告書用20240410追記
  createReportModalClose: () => void;//報告書用20240410追記
};

/**
 * 情報登録モーダルの開閉状態管理ストア
 */
const useCreateModal = create<Store>(set => ({
  isCreateModal: false,
  isCreateDamageModal: false,
  isCreateIndpinModal: false,
  isCreateTrapModal: false,
  isCreateCameraModal: false,
  isCreatePrevModal: false,//柵用20230412追記
  isExpPictureModal: false,//画像用20230407追記
  isCreateReportModal: false,//報告書用20240410追記
  createModalToggle: () => set(state => ({ isCreateModal: !state.isCreateModal })),
  createModalClose: () => set({ isCreateModal: false }),
  createDamageModalOpen: () => set({ isCreateDamageModal: true }),
  createDamageModalClose: () => set({ isCreateDamageModal: false }),
  createIndpinModalOpen: () => set({ isCreateIndpinModal: true }),
  createIndpinModalClose: () => set({ isCreateIndpinModal: false }),
  createTrapModalOpen: () => set({ isCreateTrapModal: true }),
  createTrapModalClose: () => set({ isCreateTrapModal: false }),
  createCameraModalOpen: () => set({ isCreateCameraModal: true }),
  createCameraModalClose: () => set({ isCreateCameraModal: false }),
  createPrevModalOpen: () => set({ isCreatePrevModal: true }),//柵用20230412追記
  createPrevModalClose: () => set({ isCreatePrevModal: false }),//柵用20230412追記
  createPictureModalOpen: () => set({ isExpPictureModal: true }),//画像用20230407追記
  createPictureModalClose: () => set({ isExpPictureModal: false }),//画像用20230407追記
  createReportModalOpen: () => set({ isCreateReportModal: true }),//報告書用20240410追記
  createReportModalClose: () => set({ isCreateReportModal: false }),//報告書用20240410追記
}));

export default useCreateModal;